module.exports = __webpack_public_path__ + "static/playgroup-3@2x-b6148a764c2165fb144265036eaa29f9.jpg";